/**
 * 页面公共方法(可以直接使用)
 */
import { throttle } from './common';
const Base64 = require('js-base64').Base64;
export default {
	install(Vue, options) {
		Vue.mixin({
			methods: {

				_goPush: throttle(function (url, params = {}) {
					window._global.back = false;
					this.$router.push({
						name: url,
						params: params
					})
				}, 150),

				_goPath: throttle(function (url = '', params = {}) {
					if (url == '') {
						url = 'home';
					}
					window._global.back = false;
					this.$router.push({
						path: url,
					})
				}, 150),

				_goBack() {
					window._global.back = true;
					//console.log('state',window.history.state)
					if (window.history.state) {
						this.$router.go(-1)
					} else {
						this.$router.push('/')
					}

				},
				_goAdurl(url) {
					// console.log('图片跳转params', url);
					this.$router.push(url)
				},
				_setData(obj) {
					if (typeof (obj) == 'object' && !this.$lo.isEmpty(obj)) {
						const that = this;
						that.$lo.forIn(obj, function (v, k) {
							console.log('赋值', k, v)
							that[k] = v;
						});
					}
				},
				_goReplace(url, params = {}) {
					window._global.back = false;
					this.$router.replace({
						name: url,
						params: params
					})
				},
				_goTop() {//回到头部

					window.scrollTo(0, 0)
				},
				_getGlobal(key) {
					return window._global[key] ? window._global[key] : '';
				},
				_base64_encode(val) {
					return val ? Base64.encode(val) : '';
				},
				_base64_decode(val) {
					return val ? Base64.decode(val) : '';
				},
				_http_or_https(url) {
					let pre = ('https:' == location.protocol ? 'https:' : 'http:');
					return pre + url;
				},
				_img_format(url) {
					if (url.indexOf('//') == -1) {
						url = '//www.tuijiewang.com' + url;
					}
					let pre = ('https:' == location.protocol ? 'https:' : 'http:');
					return pre + url;
				},
				_keep_alive() {
					if (this.$vnode && this.$vnode.parent) {
						return (!_global.back || this.$vnode.parent.componentInstance.keys.length == 0);
					} else {
						return !_global.back;
					}
				},
				_login_back() {
					let from = this.$storage.get("from");
					if (from) {
						this.$router.replace(from);
					} else {
						this._goPush("Center");
					}
				},
				_slice(str, len = 1) {
					return str.slice(0, str.length - len);
				},
				// 统一提示处理
				_notice(obj) {
					if (obj == ''){
						return;
					}
					for (let key in obj) {
						if (obj.hasOwnProperty(key) && obj[key].notice) { // 确保key是对象自身的属性
							 let notice = obj[key].notice;
							 switch (notice.type) {
								case 1: //滚动
									this.$parent.onChangeMessage(notice);
									break;
								case 2: //弹窗
									this.$dialog.confirm({
										title: notice.title,
										message: notice.content,
										showCancelButton: notice.link_m ? true : false,
										confirmButtonText: '确认',
										cancelButtonText: '详情'
									}).catch(() => {
										// on cancel详情跳到金豆明细
										this.$router.push({
											name: notice.link_m.s,
											params: notice.link_m.p,
										})
									});
									break;
								case 3: //轻提示
									if (notice.content) {
										this.$toast(notice.content, {duration: (notice.second || 2) * 1000 });
									}
								break;
								default:
									break;
							 }
						}
					}
				}
			},





			// beforeRouteLeave: function(to, from, next) {
			// 	console.log('beforeRouteLeave',to)

			// 	next();
			// },

		})
	}

}



// WEBPACK FOOTER //
// ./src/box/method.js